import { render } from "./ModalCustomer.vue?vue&type=template&id=5340d2cb"
import script from "./ModalCustomer.vue?vue&type=script&lang=js"
export * from "./ModalCustomer.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__